import { useEffect, useState } from "react";

import type { ContractResponse, ContractsAPIResponse } from "./types";
import useFetchContract from "./use-fetch-contract";

export default function useContracts() {
  const [contracts, setContracts] = useState<ContractResponse[] | null>(null);

  const [error, setError] = useState<Error | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  const {
    isLoading: useFetchContractIsLoading,
    error: useFetchContractError,
    get,
  } = useFetchContract();

  useEffect(() => {
    const fetch = async () => {
      try {
        const contracts = (await get("contracts")) as ContractsAPIResponse;
        setContracts(contracts.data);
      } catch (e) {
        if (e instanceof Error) {
          setError(e);
        }
      } finally {
        setIsLoading(false);
      }
    };

    if (!contracts && !isLoading && !useFetchContractIsLoading && !error) {
      setIsLoading(true);
      fetch();
    }
  }, [contracts, isLoading, useFetchContractIsLoading, error, get]);

  return {
    contracts,
    isLoading: isLoading || useFetchContractIsLoading,
    error: error || useFetchContractError,
  };
}
